import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IUserList } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}/vendor`;

interface IState {
  data: IUserList[];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const userList = createAsyncThunk('user-settings/user-list', async () => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<IUserList[]>(`${VENDOR_MC_URL}/${userId}/user`);
  return res.data;
});

const addressSlice = createSlice({
  name: 'user-list',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(userList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(userList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.done = true;
    });
    builder.addCase(userList.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
    });
    //
  },
});
export const { setError } = addressSlice.actions;
export default addressSlice.reducer;
